module.exports = __webpack_public_path__ + "assets/img/call-conference.png";